import { descriptionId } from '@rjsf/utils'
import { humanizeVariableName } from '../../variableLabel'

const hasTitle = (schema: { title?: unknown }): boolean => typeof schema.title === 'string' && schema.title.length > 0

export const displayLabelOf = (label: string, schema: { title?: unknown }): string => (hasTitle(schema) ? label : humanizeVariableName(label))

export const headingOf = (schema: { title?: unknown }, name: string | undefined): string | undefined =>
  hasTitle(schema) ? String(schema.title) : name ? humanizeVariableName(name) : undefined

export const requiredLabel = (label: string, required: boolean | undefined): string => (required ? `${label} (required)` : label)

export interface FieldHint {
  text: string
  elementId: string
}

export const fieldHintOf = (id: string, description: unknown): FieldHint | undefined =>
  typeof description === 'string' && description.length > 0 ? { text: description, elementId: descriptionId(id) } : undefined

export const fieldNameOf = (id: string, label: string, schema: { title?: unknown }, listItem: unknown): string => {
  const listItemIndex = listItem === true ? /_(\d+)$/.exec(id) : null
  return listItemIndex ? `${displayLabelOf(label.replace(/-\d+$/, ''), schema)} ${Number(listItemIndex[1]) + 1}` : displayLabelOf(label, schema)
}
